import { SVGProps } from "react";
import {
  NavVoucherIcon,
  NavRequestIcon,
  NavLogsIcon,
  NavExaminerIcon,
  NavAnnouncementIcon,
  NavUserIcon,
  NavNotificationIcon,
  NavFinanceIcon,
  NavExamIcon,
  NavHomeIcon,
  NavProfileIcon,
} from "../assets/navIcons";

import {
  VoucherManagement,
  Examiner,
  Announcement,
  Users,
  Notifications,
  Finance,
  Logs,
  Requests,
  Home,
  Exam,
} from "../pages";
import Profile from "../pages/Profile";
import VoucherDetail from "../pages/voucherManagement/VoucherDetail";
import ExaminerSubmissions from "../pages/examiner/ExaminerSubmissions";

export type DashbordRoute = {
  key: string;
  Icon: React.FC<SVGProps<SVGSVGElement>>;
  label: string;
  path: string;
  hidden?: boolean;
  search?: boolean;
  Component: React.ComponentType;
  permission?: string;
  /* Sidebar section this item sits under. Consecutive items sharing a
     group render together beneath one heading; omit it and the item
     just joins whatever section came before. */
  group?: string;
};

const adminRoutes: DashbordRoute[] = [
  {
    key: "0",
    Icon: NavProfileIcon,
    label: "Profile",
    path: "profile",
    Component: Profile,
    hidden: true,
  },
  {
    key: "1",
    Icon: NavHomeIcon,
    label: "Home",
    path: "home",
    Component: Home,
    permission: "home.view",
    search: true,
    group: "Overview",
  },

  {
    key: "2",
    Icon: NavExamIcon,
    label: "Exam",
    path: "exam",
    Component: Exam,
    permission: "exam.view",
    search: true,
    group: "Exams",
  },
  {
    key: "3",
    Icon: NavRequestIcon,
    label: "Requests",
    path: "request",
    Component: Requests,
    permission: "request.view",
    search: true,
  },
  {
    key: "8",
    Icon: NavExaminerIcon,
    label: "Examiner",
    path: "examiner",
    Component: Examiner,
    permission: "examiner.view",
    search: true,
  },
  {
    key: "81",
    Icon: NavExaminerIcon,
    label: "Examiner",
    path: "examiner/submissions",
    Component: ExaminerSubmissions,
    hidden: true,
    permission: "examiner.view",
    search: true,
  },
  {
    key: "6",
    Icon: NavVoucherIcon,
    label: "Voucher Management",
    path: "voucher-management",
    Component: VoucherManagement,
    permission: "voucher.view",
    search: true,
  },
  {
    key: "61",
    Icon: NavVoucherIcon,
    label: "Voucher Management",
    path: "voucher-management/:id",
    Component: VoucherDetail,
    hidden: true,
    permission: "voucher.view",
    search: true,
  },
  {
    key: "10",
    Icon: NavUserIcon,
    label: "User",
    path: "user",
    Component: Users,
    permission: "user.view",
    search: true,
    group: "People",
  },
  {
    key: "7",
    Icon: NavLogsIcon,
    label: "Logs",
    path: "logs",
    Component: Logs,
    permission: "logs.view",
    search: true,
    group: "Insights",
  },
  {
    key: "11",
    Icon: NavFinanceIcon,
    label: "Finance",
    path: "finance",
    Component: Finance,
    permission: "finance.view",
    search: true,
  },
  {
    key: "9",
    Icon: NavAnnouncementIcon,
    label: "Announcement",
    path: "announcement",
    Component: Announcement,
    permission: "announcement.view",
    search: true,
    group: "Updates",
  },
  {
    key: "12",
    Icon: NavNotificationIcon,
    label: "Notifications",
    path: "notification",
    Component: Notifications,
    permission: "notification.view",
    search: true,
  },
  // {
  //   key: "13",
  //   Icon: SupportIcon,
  //   label: "Support",
  //   path: "support",
  //   Component: Support,
  //   permission: "support.view",
  //   search: true,
  // },
];

export default adminRoutes;
